import { FC } from "react";
import BellIconSVG from "../../resources/svg/BellIconSVG";

interface NotificationsIconProps {
    count: number;
}

const NotificationsIcon: FC<NotificationsIconProps> = (props) => {
    return (
        <>
            {props.count ? (
                <span className="H10 absolute top-[-4px] left-[-8px] bg-textWarning text-white px-1 py-0.5 rounded-full">
                    +{props.count}
                </span>
            ) : (
                <></>
            )}
            <BellIconSVG className="mr-8 tmax4:mr-[30px] cursor-pointer dmax2:w-7 dmax2:h-7 text-textFaded hover:text-textWhite transition duration-300" />
        </>
    );
};

export default NotificationsIcon;
